(function( ) {

	$( document ).ready(function() {

		if( jQuery().fancybox ) {

			$( '.modal-iframe-trigger' ).fancybox({
				type : 'iframe',
				baseClass : 'modal-iframe-wrap',
				afterShow : function(){
					$( this.$iframe ).attr( 'tabindex', 0 ).focus();
				}
			});

			$( '.modal-video-trigger' ).fancybox({
				baseClass : 'modal-video-wrap'
			});

			//set form variable for newsletter
			var form = $( '.form-newsletter-form' );

			$( '.modal-form-trigger' ).fancybox({

				type : 'inline',

				baseClass : 'modal-inline-wrap',
				afterClose : function(){

					$( '.form-newsletter-title', form ).text( 'Sign-up to Receive Special Offers and News!' );
					$( '.form-newsletter-message', form ).html( '' );
					$( '#form-newsletter-consent', form ).prop( 'checked', false );
					$( '.input-group', form ).css( 'display', 'block' );
					$( '.form-newsletter-submit-button').css( 'background-color', '#D13239');
					$( '.form-newsletter-submit-button').html('Subscribe Now')
					$( '.form-newsletter-submit' ).css( 'display', 'block' );

				}

			});

			$( '.sticky-link-inner' ).fancybox({
				type : 'inline',
				baseClass : 'modal-inline-wrap',
				touch: false,
				afterClose : function(){

					$inputs = $( '.contest-input' );

					$inputs.each( function() {

						$( this ).val( '' );

					});

					$( '#form-contest-terms-consent' ).prop( 'checked', false );
					$( '#form-contest-newsletter' ).prop( 'checked', false );

					$( '.form-contest-inner' ).show();
					$( '.form-contest-legal' ).show();
					$( '.form-contest-confirmation' ).hide();
					$( '.form-contest-already-submitted' ).hide();

				}

			});

			$( '.modal-inline-trigger' ).fancybox({
				type : 'inline',
				baseClass : 'modal-inline-wrap'
			});

		}

		$( '[data-toggle-active]' ).on( 'click', function( event ){

			event.preventDefault();

			var target = $( this ).data( 'toggle-active' );
			$( event.currentTarget ).toggleClass( 'active' );
			$( target ).toggleClass( 'active' );

			return false;

		});

		$( '[data-toggle-active-form]' ).on( 'click', function( event ){

			event.preventDefault();

			var target = $( this ).data( 'toggle-active-form' );
			$( event.currentTarget ).toggleClass( 'active' );
			$( target ).toggleClass( 'active' );
			$( target ).focus();

			return false;

		});

		var $slider = $( '.slider-container' );

		$slider.each( function( key, slider ) {
			console.log( slider );
			$( slider ).slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: $( slider ).children().length > 1,
				autoplay: true,
				autoplaySpeed: ( parseInt( $( slider ).data( 'slide-speed' ) ) * 1000 ),
				pauseOnHover: true,
				pauseOnDotsHover: true,
				adaptiveHeight: true
			});

		});



		$( '.scroller-wrap' ).slick({
			infinite : true,
			slidesToShow : 5,
			slidesToScroll : 1,
			arrows : false,
			dots : false,
			responsive: [
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1
					}
				},
				{
					breakpoint: 960,
					settings: {
						slidesToShow: 3
					}
				}
			]
		});

		// globally open external links in a new window

		var links = document.links;

		for (var i = 0, linksLength = links.length ; i < linksLength ; i++) {
			if (links[i].hostname !== window.location.hostname) {
				links[i].target = '_blank';
				links[i].rel = 'noreferrer noopener';
			}
		}


		// resize iframes
		var iframes = $( 'iframe' );

		iframes.each(function(){

			$( this ).data( 'ratio', this.height / this.width ).removeAttr( 'width' ).removeAttr( 'height' );

		});

		$( window ).resize(function(){

			iframes.each(function(){

				var width = $( this ).parent().width();
				$( this ).width( width ).height( width * $( this ).data( 'ratio' ) );

			});

		}).resize();

		if( $( '.sticky-link' ).length > 0 ) {

			$( '.sticky-link' ).removeClass( 'hide' );

		}

		if( document.cookie.indexOf( 'clearedCache' ) == -1 ) {

			document.cookie = 'cart=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			document.cookie = 'cart_sig=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			document.cookie = 'cart_ts=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			document.cookie = 'cart=; Path=/; domain=.fujifilmprintlife.ca; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

			document.cookie='clearedCache=true';

		}

		var scrollPostion = 0;

		$( window ).scroll( function() {

			scrollPostion = $( window ).scrollTop();

			//if sticky link is on the page, slides it offscreen so it doesn't block footer when the user scrolls to the bottom of the page
			if( $( '.sticky-link' ).length > 0 ) {

				var winheight = $( window ).height()
				var docheight = $( document ).height()
				var trackLength = docheight - winheight
				var pctScrolled = Math.floor( scrollPostion / trackLength * 100 )

				if( pctScrolled >= 99 ) {

					$( '.sticky-link' ).addClass( 'hidden' );

				} else if ( pctScrolled < 99 && !$( '.sticky-link' ).hasClass( 'perma-hidden' ) ) {

					$( '.sticky-link' ).removeClass( 'hidden' );

				}

			}

		});

		$( '[data-toggle-close]' ).on( 'click', function( event ){

			event.preventDefault();

			var target = $( this ).data( 'toggle-close' );

			$( '.' + target ).removeClass( 'active' );

			return false;

		});

		if (document.cookie.includes( 'stickyLinkHidden' )) {

			$( '.sticky-link' ).addClass( 'perma-hidden' );

		}

		$( '.js-close-sticky-link' ).on( 'click', function() {

			$( '.sticky-link' ).addClass( 'perma-hidden' );

			document.cookie = 'stickyLinkHidden=true;max-age=' + (60 * 60 * 24); // hide for 1 day

		});


		$( '.accordion-title' ).on( 'click', function(){

			var $accordion = $( this ).parent( '.accordion' );
			var $content = $accordion.find( '.accordion-content' );

			$content.slideToggle();
			$accordion.toggleClass( 'active' );

			var expanded = $accordion.hasClass( 'active')  ? 'true' : 'false';
			$accordion.find( '.accordion-svg' ).attr( 'aria-expanded', expanded );

			var $chevron = $accordion.find( '.accordion-svg svg' );

			if ( expanded === 'true' ) {

				$chevron.css( 'transform', 'rotate(-90deg)' );

			} else {

				$chevron.css( 'transform', 'rotate(90deg)' );

			}

		});


		// Check if the browser is Safari
		var isSafari = /^((?!chrome|android).)*safari/i.test( navigator.userAgent );

		if (isSafari) {

			$( 'ol' ).css( 'padding-left', '5px' );

		}


		$(document).on('keydown', function(event) {

			var modal = $( '.js-is-modal:not(.hidden)' );

			if ( modal.length > 0 ) {

				var focusableElements = modal.find( 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' );
				var firstFocusableElement = focusableElements.first();
				var lastFocusableElement = focusableElements.last();

				if ( event.key === 'Tab' ) {
					if (event.shiftKey) {

						if ( $(document.activeElement).is( firstFocusableElement ) ) {

							event.preventDefault();
							lastFocusableElement.focus();

						}

					} else {

						if ($( document.activeElement ).is( lastFocusableElement )) {

							event.preventDefault();
							firstFocusableElement.focus();

						}
					}
				}
			}
		});

		$( '[data-toggle-active]' ).on( 'click', function( event ){

			var target = $( this ).data( 'toggle-active' );
			$( target ).toggleClass( 'off-screen' );


			if ( !$( target ).hasClass( 'off-screen' )) {

				$( target ).find( 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' ).first().focus();

			} else {

				var returnElement = $( this ).data( 'return-element' );
				if ( returnElement ) {

					$( returnElement ).focus();

				}

			}

		});

		if( $( '#product-timestamp' ).length > 0 ) {

			$( '#product-timestamp' ).val( crypto.randomUUID() );

		}

		if( $( '.campaign-key-element' ).length > 0 ) {

			var key = $( '.campaign-key-element' ).data( 'campaign-key' );
			var links = $( '.header' ).nextUntil( '.footer' ).find( 'a' ).addBack( 'a' );

			links.each( ( index, link ) => {

				if( $( link ).attr( 'href' ).indexOf( '?' ) >= 0 ) {

					$( link ).attr( 'href', $( link ).attr( 'href' ) + '&referer=' + key );

				} else {

					$( link ).attr( 'href', $( link ).attr( 'href' ) + '?referer=' + key );

				}

			});

		}

		var urlParams = new URLSearchParams( window.location.search );

		if( urlParams.has( 'referer' ) ) {

			var key = urlParams.get( 'referer' );
			var links = $( '.header' ).nextUntil( '.footer' ).find( 'a' ).addBack( 'a' );

			links.each( ( index, link ) => {

				if( $( link ).attr( 'href' ).indexOf( '?' ) >= 0 ) {

					$( link ).attr( 'href', $( link ).attr( 'href' ) + '&referer=' + key );

				} else {

					$( link ).attr( 'href', $( link ).attr( 'href' ) + '?referer=' + key );

				}

			});

		}

		if( urlParams.has( 'referer' ) && $( '.dynamic-property-inputs-wrapper' ) ) {

			$( '.dynamic-property-inputs-wrapper' ).append( '<input id="referer" type="hidden" name="properties[referer]" value="' + urlParams.get( 'referer' ) + '">' );

		}

	});

	$( window ).on('load', function() {
		// Grabbing dates from Shopify
		var startDate = $( '#banner-content ').data( 'start-date' );
		var endDate = $( '#banner-content' ).data( 'end-date' );

		// Turning the data into Date objects
		var startDateObj = new Date( startDate );
		var endDateObj = new Date( endDate );

		function onCountdownEnd() {

			$( '#banner-content' ).hide();
			clearInterval( countdownInterval );

		}

		if ( !isNaN(startDateObj.getTime()) && !isNaN(endDateObj.getTime()) ) {

			var countdownInterval = setInterval(function() {

				var now = new Date();

				if ( now >= startDateObj && now <= endDateObj ) {

					var timeDifference = endDateObj - now;

					if ( timeDifference <= 0 ) {

						onCountdownEnd();

					} else {

						var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
						var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
						var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
						var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

						$( '#countdown' ).text( days + "d " + hours + "h " + minutes + "m " + seconds + "s" );
						$( '#banner-content' ).show();

					}

				} else {

					$( '#banner-content' ).hide();

				}

			}, 1000);
		} else {

			console.log("Invalid start or end date format.");

		}

	});

	$( document ).ready(function() {

		var firstTab = $( ".faq-tab" ).first();
		var firstTabTarget = firstTab.data( "tab" );
		$( "#" + firstTabTarget ).show();


		$( ".faq-tab" ).on("click", function() {

			var target = $( this ).data( "tab" );

			$( ".faq-tab" ).removeClass( "bg-blue text-white" ).addClass( "bg-transparent text-black" );

			$( this ).removeClass( "bg-transparent text-black" ).addClass( "bg-blue text-white" );

			$( ".faq-item" ).hide();

			$( "#" + target ).fadeIn();

			if ( $( this ).is( ".faq-tab:last")) {

				$( this ).addClass( " rounded-tr-md lg:rounded-tr-none rounded-br-md lg:rounded-tl-none lg:rounded-bl-md lg:rounded-br-md" );
			}

			if ( $( this ).is( ".faq-tab:first")) {

				$( this ).addClass( " bg-blue text-white rounded-tr-none lg:rounded-tr-md rounded-bl-md lg:rounded-bl-none rounded-tl-md" );
			}

		});

		$( "#faq-search" ).on("input", function () {

			var searchTerm = $( this ).val().toLowerCase();
			var found = false;

			$( ".faq-item" ).each(function () {

				var textContent = $( this ).text().toLowerCase();
				var tabId = $( this ).attr( "id" );

				if ( textContent.includes( searchTerm ) ) {

					$( this ).show();
					found = true;

					$( ".faq-tab" ).removeClass( "bg-blue text-white" ).addClass( "bg-transparent text-black" );
					$( ".faq-tab[data-tab='" + tabId + "']" ).addClass( "bg-blue text-white" );

					if ( $( ".faq-tab[data-tab='" + tabId + "']").is( ":last-child" ) ) {
						$( ".faq-tab[data-tab='" + tabId + "']" ).addClass( " rounded-tr-md lg:rounded-tr-none rounded-br-md lg:rounded-tl-none lg:rounded-bl-md lg:rounded-br-md" );
					}

				} else {

					$( this ).hide();

				}
			});

			if ( !found && $( ".faq-no-results" ).length === 0 ) {

				$( ".faq-content" ).append( "<div class='faq-no-results text-gray text-center m-auto h-full flex justify-center items-center'>No results found</div>" );
				$( ".faq-tab" ).removeClass( "bg-blue text-white" ).addClass( "bg-transparent text-black" );

			} else if ( found ) {

				$( ".faq-no-results" ).remove();
			}

			if ( searchTerm === "" ) {

				$( ".faq-item" ).hide();
				$( ".faq-item" ).first().show();

				$( ".faq-tab" ).removeClass( "bg-blue text-white" ).addClass( "bg-transparent text-black" );
				$( ".faq-tab" ).first().addClass( "bg-blue text-white" );

				$( ".faq-no-results" ).remove();

			}
		});

		$( "#faq-clear" ).on("click", function () {
			$( "#faq-search" ).val("");
			$( ".faq-item" ).hide();
			$( ".faq-item" ).first().show();

			$( ".faq-tab" ).removeClass( "bg-blue text-white" ).addClass( "bg-transparent text-black" );
			$( ".faq-no-results" ).remove();

			$( ".faq-tab" ).first().trigger("click");
		});

		$( document ).on("click", ".faq-tab", function () {
			$( ".faq-no-results" ).remove();
		});


	});

})();
